import { db, storage } from '@/firebase'

export default {
    getCaracteristicas({ commit }) {
        let devolver = [];
        return db.collection('caracteristicas').get()
            .then((res) => {
                res.forEach(doc => {
                    let aux = doc.data();
                    aux.id = doc.id;
                    devolver.push(aux);
                });
                return devolver;
            })
            .then((res) => {

                var actions = res.map(function (item) {
                    if (item.imagen) {
                        return item;
                    } else {
                        var storageRef = storage.ref('imagenes/caracteristicas/' + item.id + '.jpg');
                        //var spaceRef = storageRef.child('imagenes/caracteristicas/' + element.id + '.jpg');
                        return storageRef.getDownloadURL()
                            .then((r) => {
                                item.imagen = r;
                                return db.collection('caracteristicas').doc(item.id).set({
                                    imagen: r
                                }, { merge: true })
                                //   return item;
                            })
                            .then(r => item)
                            .catch((e) => {
                                console.log(e);
                                item.imagen = false;
                                return item;
                            })
                    }
                });
                Promise.all(actions)
                    .then((r) => {
                        commit('setCaracteristicasArray', r)
                    })
                    .catch((e) => {
                        console.log(e);
                    })
                // commit('setCaracteristicasArray',res);
            })


    },
    addCaracteristica({ rootState }, carac) {
        let id = carac.id;
        let imagen = carac.imagen
        delete carac.id;
        delete carac.imagen
        var ref = null
        if (id) {
            ref = db.collection('caracteristicas').doc(id).set(carac, { merge: true })
        } else {
            ref = db.collection('caracteristicas').add(carac)
        }
        return ref
            .then((res) => {
                if (!id) {
                    id = res.id;
                }
                if (imagen) {
                    var storageRef = storage.ref();
                    var ref = storageRef.child('imagenes/caracteristicas/' + id + '.jpg');
                    return ref.put(imagen);
                }

            })
    },
    ordenarCaracteristicas({ }, array) {
        let arrayPromesas = [];
        array.forEach(element => {
            arrayPromesas.push(
                db.collection('caracteristicas')
                    .doc(element.id)
                    .set({ orden: element.orden }, { merge: true })
            )
        });
        return Promise.all(arrayPromesas);
    },
    deleteCaracteristica({ }, caract) {
        return db.collection('caracteristicas').doc(caract.id).delete()
    }
}